var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.selectedRetouchings),function(selectedRetouching,index){return _c('input',{key:index,attrs:{"name":("RetouchingPackage_" + (selectedRetouching.offerPackageId) + "_" + (selectedRetouching.frameId)),"type":"hidden","value":"true"}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd5a590c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./WebResources/vue/shared/components/catalog/RetouchingInputs.vue
// module id = 833
// module chunks = 0 2